import _objectWithoutProperties from "/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useState, useCallback, useMemo, cloneElement, useRef, createElement, useEffect, forwardRef } from 'react';
import clsx from 'clsx';
import mergeRefs from 'react-merge-refs';
import { nanoid } from 'nanoid/non-secure';
var INDETERMINATE_STATE = 'indeterminate';

var dispatch = function dispatch(value) {
  return function (state) {
    if (Array.isArray(state)) {
      var index = state.indexOf(value);

      if (index === -1) {
        state.push(value);
      } else {
        state.splice(index, 1);
      }

      return _toConsumableArray(state);
    } else if (value !== '') {
      return [value];
    }

    return !state;
  };
};

var useCheckboxState = function useCheckboxState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$state = _ref.state,
      initialState = _ref$state === void 0 ? false : _ref$state,
      onChange = _ref.onChange;

  var _useState = useState(function () {
    if (typeof initialState === 'string' && initialState !== INDETERMINATE_STATE) {
      return [initialState];
    }

    return initialState;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return {
    state: state,
    setState: setState,
    onChange: useCallback(function (e) {
      var value = e.currentTarget.value;
      setState(dispatch(value));

      if (typeof onChange === 'function') {
        onChange(e);
      }
    }, [onChange])
  };
};

var lockedStyles = {
  pointerEvents: 'none'
};
/**
 * A simplier way to prevent checking when PCR is in locked mode.
 * This is way simplier than controlling the checkbox using
 * event handlers. Supports IE 11+
 */

var useLocked = function useLocked(_ref2) {
  var locked = _ref2.locked,
      style = _ref2.style;

  if (locked) {
    return _objectSpread(_objectSpread({}, lockedStyles), style);
  }

  return style;
};

var useIcon = function useIcon(icon) {
  return useMemo(function () {
    if (icon) {
      var type = 'icon';

      if (icon.type === 'img') {
        type = 'image';
      } else if (icon.type === 'svg') {
        type = 'svg';
      } // icons that contain `type` substring
      // won't fail with a word boundary search


      var re = new RegExp("\\b".concat(type, "\\b"));
      return {
        iconType: icon.props['data-type'] || type,
        icon: icon.props.className && !re.test(icon.props.className) ? cloneElement(icon, _objectSpread(_objectSpread({}, icon.props), {}, {
          className: clsx(icon.props.className, type)
        })) : icon
      };
    }

    return {};
  }, [icon]);
};

var isDefault = function isDefault(animation, type) {
  if (type) {
    return false;
  }

  return !animation || animation === 'smooth' || animation === 'pulse';
};
/**
 * Responsible for returning an object used by classnames
 * to properly add the className values to the .pretty element.
 */


var useClassNames = function useClassNames(props, isSwitch) {
  var _ref3;

  var animation = props.animation,
      bigger = props.bigger,
      locked = props.locked,
      plain = props.plain,
      shape = props.shape,
      variant = props.variant,
      iconType = props.iconType,
      hasFocus = props.hasFocus;
  return _ref3 = {
    'p-default': !isSwitch && isDefault(animation, iconType),
    'p-bigger': bigger,
    'p-locked': locked,
    'p-plain': plain,
    'p-has-focus': hasFocus
  }, _defineProperty(_ref3, "p-".concat(animation), animation), _defineProperty(_ref3, "p-".concat(shape), shape), _defineProperty(_ref3, "p-".concat(variant), variant), _defineProperty(_ref3, "p-".concat(iconType), iconType), _ref3;
};

var isBoolean = function isBoolean(e) {
  return typeof e === 'boolean';
};

var isNullish = function isNullish(e) {
  return e === null || e === undefined;
};

var isIndeterminate = function isIndeterminate(e) {
  return e === 'indeterminate';
};
/**
 * A generic way to setup controlled components by
 * removing  state hook return results, setting `checked`,
 * and `value` props too.
 */


var useControlled = function useControlled(props) {
  // remove state and state dispatch from the props
  // eslint-disable-next-line prefer-const
  var checked = props.checked,
      state = props.state,
      setState = props.setState,
      value = props.value,
      defaultValue = props.defaultValue,
      rest = _objectWithoutProperties(props, ["checked", "state", "setState", "value", "defaultValue"]); // if a dispatcher is used, then we're good to run the rest
  // of the logic


  if (setState) {
    // if state is defined and checked is NOT defined
    // then use state to set the value of checked.
    if ((isBoolean(state) || isIndeterminate(state)) && !isBoolean(checked) && isNullish(checked)) {
      checked = !!state;
    } else if (Array.isArray(state)) {
      // otherwise set checked true if the value is contained
      // within the state.
      checked = state.includes(value);
    } else if (isNullish(checked)) {
      // The type is not a boolean and is probably a string.
      // If you're attempting to use this hook in a different
      // way, then you should considering controlling the component
      // yourself. Object.is used here just in case ;)
      checked = Object.is(state, value);
    } // preset the value prop in controlled mode to an empty
    // string to prevent 'on' values. Use the defaultValue
    // if provided


    if (isNullish(value)) {
      value = defaultValue || '';
    }
  }

  return _objectSpread({
    checked: checked,
    value: value,
    state: state
  }, rest);
};

var PREFIX = 'pcr_';

var useUUID = function useUUID() {
  return useRef(PREFIX + nanoid(8)).current;
};
/**
 * Filters out the noise of prop mayhem with PCR. This separates
 * all props from the native HTML props that will eventually get passed
 * to the input element. Generated PCR UUIDs are created here, unless
 * user has specified one of their own.
 */


var useCommonProps = function useCommonProps(props) {
  var defaultId = useUUID();

  var locked = props.locked,
      color = props.color,
      variant = props.variant,
      animation = props.animation,
      children = props.children,
      style = props.style,
      _props$id = props.id,
      id = _props$id === void 0 ? defaultId : _props$id,
      className = props.className,
      bigger = props.bigger,
      hasFocus = props.hasFocus,
      rest = _objectWithoutProperties(props, ["locked", "color", "variant", "animation", "children", "style", "id", "className", "bigger", "hasFocus"]);

  return {
    locked: locked,
    color: color,
    variant: variant,
    animation: animation,
    children: children,
    id: id,
    className: className,
    bigger: bigger,
    style: style,
    hasFocus: hasFocus,
    htmlProps: rest
  };
};
/**
 * Responsible for extracting common props for radio and checkbox
 * controls.
 */


var useCheckboxRadioProps = function useCheckboxRadioProps(props) {
  var shape = props.shape,
      plain = props.plain,
      icon = props.icon,
      indeterminate = props.indeterminate,
      hasFocus = props.hasFocus,
      rest = _objectWithoutProperties(props, ["shape", "plain", "icon", "indeterminate", "hasFocus"]);

  return _objectSpread({
    shape: shape,
    plain: plain,
    icon: icon,
    indeterminate: indeterminate
  }, useCommonProps(rest));
};
/**
 * A tiny component to abstract away pretty-checkbox "state" div.
 * Shared by all components.
 */


var State = function State(_ref4) {
  var color = _ref4.color,
      icon = _ref4.icon,
      id = _ref4.id,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["color", "icon", "id", "children"]);

  return createElement("div", _objectSpread({
    className: clsx('state', color && "p-".concat(color))
  }, rest), icon, createElement("label", {
    htmlFor: id
  }, children));
};

State.displayName = 'State';

var useIndeterminate = function useIndeterminate(_ref5) {
  var checked = _ref5.checked,
      state = _ref5.state,
      indeterminateFromProps = _ref5.indeterminate;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      indeterminate = _useState4[0],
      setStatus = _useState4[1];

  var ref = useRef(null);
  useEffect(function () {
    if (state !== undefined && ref.current) {
      setStatus(state === 'indeterminate');
    }
  }, [state]); // if a prop is passed mark the indeterminate state
  // we should check to ensure state isn't set to indeterminate
  // since we don't want ot clobber the state value if
  // it is defined.

  useEffect(function () {
    if (state !== 'indeterminate' && ref.current && typeof indeterminateFromProps !== 'undefined') {
      ref.current.checked = indeterminateFromProps; // fix needs to come from pretty-checkbox
      // ref.current.indeterminate = indeterminateFromProps;

      setStatus(indeterminateFromProps);
    }
  }, [indeterminateFromProps, state]);
  return {
    ref: ref,
    'aria-checked': indeterminate ? 'mixed' : checked
  };
};

var Checkbox = forwardRef(function (props, ref) {
  var _useControlled = useControlled(props),
      checked = _useControlled.checked,
      value = _useControlled.value,
      state = _useControlled.state,
      rest = _objectWithoutProperties(_useControlled, ["checked", "value", "state"]);

  var _useCheckboxRadioProp = useCheckboxRadioProps(rest),
      children = _useCheckboxRadioProp.children,
      locked = _useCheckboxRadioProp.locked,
      color = _useCheckboxRadioProp.color,
      id = _useCheckboxRadioProp.id,
      className = _useCheckboxRadioProp.className,
      style = _useCheckboxRadioProp.style,
      indeterminate = _useCheckboxRadioProp.indeterminate,
      propsIcon = _useCheckboxRadioProp.icon,
      htmlProps = _useCheckboxRadioProp.htmlProps;

  var _useIndeterminate = useIndeterminate({
    state: state,
    checked: checked,
    indeterminate: indeterminate
  }),
      intRef = _useIndeterminate.ref,
      aria = _objectWithoutProperties(_useIndeterminate, ["ref"]);

  var styles = useLocked({
    locked: locked,
    style: style
  });

  var _useIcon = useIcon(propsIcon),
      icon = _useIcon.icon,
      iconType = _useIcon.iconType;

  return createElement("div", {
    style: styles,
    className: clsx('pretty', useClassNames(_objectSpread(_objectSpread({}, props), {}, {
      iconType: iconType
    })), className)
  }, createElement("input", _objectSpread(_objectSpread({
    ref: mergeRefs([ref, intRef]),
    value: value,
    type: "checkbox",
    id: id,
    checked: checked
  }, aria), htmlProps)), createElement(State, {
    id: id,
    icon: icon,
    color: color
  }, children));
});
Checkbox.displayName = 'Checkbox';

var useRadioState = function useRadioState() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$state = _ref6.state,
      initialState = _ref6$state === void 0 ? false : _ref6$state,
      onChange = _ref6.onChange;

  var _useState5 = useState(initialState),
      _useState6 = _slicedToArray(_useState5, 2),
      state = _useState6[0],
      setState = _useState6[1];

  return {
    state: state,
    setState: setState,
    onChange: useCallback(function (e) {
      var value = e.currentTarget.value;
      setState(function (current) {
        if (value !== '') {
          return value;
        }

        return !current;
      });

      if (typeof onChange === 'function') {
        onChange(e);
      }
    }, [onChange])
  };
};

var Radio = forwardRef(function (props, ref) {
  var _useControlled2 = useControlled(props),
      checked = _useControlled2.checked,
      value = _useControlled2.value,
      state = _useControlled2.state,
      rest = _objectWithoutProperties(_useControlled2, ["checked", "value", "state"]);

  var _useCheckboxRadioProp2 = useCheckboxRadioProps(rest),
      _useCheckboxRadioProp3 = _useCheckboxRadioProp2.shape,
      shape = _useCheckboxRadioProp3 === void 0 ? 'round' : _useCheckboxRadioProp3,
      children = _useCheckboxRadioProp2.children,
      locked = _useCheckboxRadioProp2.locked,
      color = _useCheckboxRadioProp2.color,
      id = _useCheckboxRadioProp2.id,
      className = _useCheckboxRadioProp2.className,
      style = _useCheckboxRadioProp2.style,
      propsIcon = _useCheckboxRadioProp2.icon,
      htmlProps = _useCheckboxRadioProp2.htmlProps;

  var styles = useLocked({
    locked: locked,
    style: style
  });

  var _useIcon2 = useIcon(propsIcon),
      icon = _useIcon2.icon,
      iconType = _useIcon2.iconType;

  return createElement("div", {
    style: styles,
    className: clsx('pretty', useClassNames(_objectSpread(_objectSpread({}, props), {}, {
      shape: shape,
      iconType: iconType
    })), className)
  }, createElement("input", _objectSpread({
    ref: ref,
    value: value,
    type: "radio",
    id: id,
    checked: checked
  }, htmlProps)), createElement(State, {
    id: id,
    icon: icon,
    color: color
  }, children));
});
Radio.displayName = 'Radio';

var handler = function handler(e) {
  e.currentTarget.setAttribute('aria-checked', e.currentTarget.checked + '');
};
/**
 * A small hook to help manage correct aria-checked state when switch
 * is used as an uncontrolled component. We need this to run
 * for a11y purposes. FOr the `switch` role, `aria-checked` is required.
 */


var useAriaChecked = function useAriaChecked(_ref7) {
  var setState = _ref7.setState,
      checked = _ref7.checked;
  var ref = useRef(null);
  useEffect(function () {
    var elem = ref.current;
    var bound = false;

    if (!setState && !checked && elem) {
      elem.setAttribute('aria-checked', elem.checked + '');
      elem.addEventListener('change', handler);
      bound = true;
    }

    return function () {
      if (bound && elem) {
        elem.removeEventListener('change', handler);
      }
    };
  }, [setState, checked]);
  return ref;
};

var Switch = forwardRef(function (props, ref) {
  var _useControlled3 = useControlled(props),
      checked = _useControlled3.checked,
      value = _useControlled3.value,
      state = _useControlled3.state,
      rest = _objectWithoutProperties(_useControlled3, ["checked", "value", "state"]);

  var _useCommonProps = useCommonProps(rest),
      children = _useCommonProps.children,
      locked = _useCommonProps.locked,
      color = _useCommonProps.color,
      id = _useCommonProps.id,
      className = _useCommonProps.className,
      style = _useCommonProps.style,
      htmlProps = _useCommonProps.htmlProps;

  var styles = useLocked({
    locked: locked,
    style: style
  });
  var htmlRef = useAriaChecked({
    setState: props.setState,
    checked: checked
  });
  return createElement("div", {
    style: styles,
    className: clsx('pretty', 'p-switch', useClassNames(props, true), className)
  }, createElement("input", _objectSpread({
    ref: mergeRefs([ref, htmlRef]),
    type: "checkbox",
    role: "switch",
    value: value,
    id: id,
    "aria-checked": checked,
    checked: checked
  }, htmlProps)), createElement(State, {
    id: id,
    color: color
  }, children));
});
Switch.displayName = 'Switch';
export { Checkbox, Radio, Switch, useCheckboxState, useRadioState };